"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var sticky_1 = __importDefault(require("./sticky"));
exports.default = (function () {
    var landingPageHeader = document.querySelector('.LandingPageHeader');
    var landingPageMobileNav = document.querySelector('.LandingPageHeader__mobileNav');
    var mobileIcon = document.querySelector('.LandingPageHeader__mobileIcon');
    if (!landingPageHeader || !landingPageMobileNav || !mobileIcon) {
        return false;
    }
    var stickyInstance = sticky_1.default(landingPageHeader);
    var openMobileNav = function () {
        landingPageMobileNav.classList.add('is-open');
        landingPageHeader.classList.add('mobileNavIsOpen');
        stickyInstance.freeze();
    };
    var closeMobileNav = function () {
        landingPageMobileNav.classList.remove('is-open');
        stickyInstance.unfreeze();
        // Cleanup actions that need to be run after the animation is complete.
        setTimeout(function () {
            landingPageHeader.classList.remove('mobileNavIsOpen');
        }, 250);
    };
    mobileIcon.addEventListener('click', openMobileNav);
    landingPageMobileNav.addEventListener('click', function (e) { return (e.target === landingPageMobileNav ? closeMobileNav() : false); });
});
